<template>
  <div class="panel-item"
    :class="{'is-selected': isSelected, 'has-children': hasChildren, 'has-path': hasPath, 'has-description': titleAttribute, 'cursor-disabled': isLocked}"
    :title="titleAttribute">
    <small-text v-if="path">{{ path }}</small-text>
    <span ref="name">
      <slot></slot>
    </span>
    <svg-icon @click.native="copyDescription" class="panel-item__copy" v-if="titleAttribute" :icon="copy" :width="13"
      :height="13" preserveAspectRatio="xMinYMid meet"></svg-icon>
    <svg-icon class="panel-item__arrow" v-if="hasChildren" :icon="arrow" :width="8" :height="13"></svg-icon>
  </div>
</template>

<script>
  import copy from '@/assets/svg/copy.svg'
  import arrow from '@/assets/svg/arrow.svg'
  import SvgIcon from '@/components/common/svgIcon'
  import SmallText from './SmallText.vue'
  import {copyTextToClipboard} from '@/helpers'

  export default {
    components: {
      SvgIcon,
      SmallText
    },
    props: {
      name: String,
      path: {
        type: String
      },
      hasChildren: {
        type: Boolean,
        default: false
      },
      isLocked: {
        type: Boolean,
        default: false
      },
      isSelected: {
        type: Boolean,
        default: false
      },
      description: String
    },
    data () {
      return {
        copy: Object.freeze(copy),
        arrow: Object.freeze(arrow),
        shouldDisplayTitleTooltip: true
      }
    },
    computed: {
      titleAttribute () {
        return this.shouldDisplayTitleTooltip && this.description && this.description.trim().length > 1 ? this.description : null
      },
      hasPath () {
        return !!this.path
      }
    },
    methods: {
      copyDescription (e) {
        e.stopPropagation()
        copyTextToClipboard(this.name)
      }
    }
  }
</script>

<style lang="scss">
  .panel-item {
    position: relative;
    display: flex;
    align-items: flex-start;
    padding: rem(10);
    border-left: 2px solid transparent;
    color: white;
    cursor: pointer;
    font-size: rem(16);
    list-style: none;
    text-align: left;

    span {
      min-width: 0;
      flex: 1 1 auto;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre-wrap;
      pointer-events: none;
    }

    &:hover,
    &.is-selected {
      border-left-color: color(yellow);
      background-color: #3D4B5A;

      .panel-item__arrow {
        fill: color(yellow);
      }
    }

    &.cursor-disabled {
      cursor: not-allowed;
      pointer-events: all;
    }

    &.has-path {
      flex-direction: column;
      align-items: left;

      span {
        overflow: visible;
        text-overflow: ellipsis;
        white-space: pre-wrap;
        pointer-events: none;
      }
    }
    &.has-description {
      span {
        flex: 0 1 auto;
      }
    }

    &__copy {
      padding-left: rem(10);
      fill: currentColor;
      &:hover {
        fill: color(yellow);
      }
    }

    &__arrow {
      width: rem(8) !important;
      height: rem(13) !important;
      margin-left: auto;
      padding-left: rem(10);
      flex-shrink: 0;
      fill: currentColor;
    }
  }
</style>



// WEBPACK FOOTER //
// PanelItem.vue?67e8f92c